export default __webpack_public_path__ + "img/surprised-vote.05530da.svg";